module.exports = {"411104001":"天桥街街道","411104002":"翟庄","411104100":"召陵镇","411104101":"邓襄镇","411104102":"万金镇","411104103":"老窝镇","411104104":"姬石镇","411104105":"青年镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411104.json
// module id = 1626
// module chunks = 0